<div class="alarm-page">
    <div class="filter-title">
        <h3>Filtres</h3>
    </div>
    <div class="filters">
        <label><input type="radio" [(ngModel)]="filterDay" [value]="0" name="filter"
                (click)="daysFilter()">Aujourd'hui</label>
        <label><input type="radio" [(ngModel)]="filterDay" [value]="30" name="filter" (click)="daysFilter(30)">30
            jours</label>
        <label><input type="radio" [(ngModel)]="filterDay" [value]="60" name="filter" (click)="daysFilter(60)">60
            jours</label>
        <label><input type="radio" [(ngModel)]="filterDay" [value]="90" name="filter" (click)="daysFilter(90)">90
            jours</label>
        <form *ngIf="formDate" [formGroup]="formDate">
            <div class="calendar">
                <mat-date-range-input [formGroup]="formDate" [rangePicker]="picker">
                    <input matStartDate formControlName="start" (dateChange)="selectedDate()"
                        placeholder="Date de début">
                    <input matEndDate formControlName="end" (dateChange)="selectedDate() " placeholder="Date de fin">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker color="primary"></mat-date-range-picker>
            </div>
            <mat-error *ngIf="formDate.controls.start.hasError('matStartDateInvalid')">Date de début invalide
            </mat-error>
            <mat-error *ngIf="formDate.controls.end.hasError('matEndDateInvalid')">Date de fin invalide</mat-error>
        </form>
    </div>
    <div class="alarm-table">
        <frg-table [keysColumn]="alarmColumnTable" [keysBody]="alarmList" (onChangePage)="onChangePage($event)"
            (onSort)="onSort($event)"></frg-table>
    </div>
</div>